import React, { ReactElement } from 'react';
import { IconProps } from '../index';

export default function IconArrowRight({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill='none' fillRule='evenodd'>
                <g transform='matrix(-1 0 0 1 24 0)' fill={color} fillRule='nonzero'>
                    <g transform='translate(8 4)'>
                        <path d='M7.29289322,-0.707106781 C7.68341751,-1.09763107 8.31658249,-1.09763107 8.70710678,-0.707106781 C9.09763107,-0.316582489 9.09763107,0.316582489 8.70710678,0.707106781 L0.707106781,8.70710678 C0.316582489,9.09763107 -0.316582489,9.09763107 -0.707106781,8.70710678 C-1.09763107,8.31658249 -1.09763107,7.68341751 -0.707106781,7.29289322 L7.29289322,-0.707106781 Z' />
                        <path d='M-0.707106781,8.70710678 C-1.09763107,8.31658249 -1.09763107,7.68341751 -0.707106781,7.29289322 C-0.316582489,6.90236893 0.316582489,6.90236893 0.707106781,7.29289322 L8.70710678,15.2928932 C9.09763107,15.6834175 9.09763107,16.3165825 8.70710678,16.7071068 C8.31658249,17.0976311 7.68341751,17.0976311 7.29289322,16.7071068 L-0.707106781,8.70710678 Z' />
                    </g>
                </g>
            </g>
        </svg>
    );
}
